<template>
  <div class="layer-item" :id="`layer-item-${layer.initial.id}`">
    <component
      :is="layer.description.name"
      :event="formatEventData(layer.event)"
      :initial="layer.initial"
      v-bind="layer.initial.props"
    >
    </component>
  </div>
</template>

<script>
import { productionUtil } from '@qsk/slime-core';
/**
 * 解析layer数据渲染为对应组件
 */
const { formatEventData } = productionUtil;
export default {
  props: {
    layer: Object,
  },
  methods: {
    formatEventData,
  },
};
</script>

<style lang="scss" scoped></style>
